import defaultPaymentsInfo from '../constants/defaultPaymentsInfo.js';
function buildDefaultPaymentsInfo() {
  let myWalletConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let customWalletDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    ...defaultPaymentsInfo,
    ...myWalletConfigs?.payments,
    ...customWalletDefaults
  };
}
export { buildDefaultPaymentsInfo as default };
